import { Box, } from "@material-ui/core";
import React from "react";
import { toBRL } from "../../../../utils/formatCurrency";
import { CellHead, TableBody, TableHead, Title, TableRow, TableCell, TableRowContent, TotalBoxRow, TotalBoxCell, TotalBox } from "./order.style";

export const Order = ({ orderDetail }) => {

    const { order, total, subTotal, deliveryTax, discount } = orderDetail;
    return (
        <Box marginBottom='40px'>
            <Title>
                Pedidos
            </Title>
            <Box>
                <TableHead>
                    <CellHead style={{ width: '15%' }}>Quantidade</CellHead>
                    <CellHead style={{ width: '70%' }}>Descrição</CellHead>
                    <CellHead style={{ width: '15%' }}>Preço</CellHead>
                </TableHead>
                <TableBody maxHeight='250px' overflow='auto'>
                    {
                        order.map((ord, index) => (
                            <TableRowContent key={index} odd={index % 2 == 0}>
                                <TableRow>
                                    <TableCell style={{ width: '15%' }}>
                                        {ord.quantity}
                                    </TableCell>

                                    <TableCell style={{ width: '70%' }}>
                                        <Box>{ord.name}</Box>
                                        {ord.note && (
                                            <Box style={{ fontStyle: 'italic' }}>Obs: {ord.note}</Box>
                                        )}
                                    </TableCell>

                                    <TableCell style={{ width: '15%' }}>
                                        {toBRL(ord.value)}
                                    </TableCell>
                                </TableRow>
                                {ord.complements.map((complement) => (
                                    <TableRow>
                                        <TableCell style={{ width: '15%' }}></TableCell>

                                        <TableCell style={{ width: '70%', fontSize: 12, fontWeight: 300 }}>
                                            <span>  &emsp; {complement.quantity}x {complement.name}</span>
                                        </TableCell>

                                        <TableCell style={{ width: '15%', fontSize: 12, fontWeight: 300 }}>
                                            {toBRL(complement.value)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableRowContent>
                        ))
                    }

                </TableBody>
            </Box>
            <TotalBox>
                <TotalBoxRow>
                    <TotalBoxCell style={{ width: '110px' }}>Subtotal</TotalBoxCell>
                    <TotalBoxCell style={{ width: 'calc(100% - 110px)' }}>
                        {toBRL(subTotal)}
                    </TotalBoxCell>
                </TotalBoxRow>

                {
                    (discount > 0) && (
                        <TotalBoxRow>
                            <TotalBoxCell style={{ width: '110px' }}>Desconto</TotalBoxCell>
                            <TotalBoxCell style={{ width: 'calc(100% - 110px)' }}>
                                {discount && toBRL(discount)}
                            </TotalBoxCell>
                        </TotalBoxRow>
                    )
                }

                {
                    orderDetail.type === 'Delivery' && (
                        <TotalBoxRow odd>
                            <TotalBoxCell style={{ width: '110px' }}>Taxa de entrega</TotalBoxCell>
                            <TotalBoxCell style={{ width: 'calc(100% - 110px)' }}>
                                {deliveryTax ? toBRL(deliveryTax) : 'Grátis'}
                            </TotalBoxCell>
                        </TotalBoxRow>
                    )
                }

                <TotalBoxRow odd={orderDetail.type !== 'Delivery'}>
                    <TotalBoxCell style={{ width: '110px', fontWeight: 'bold' }}>Total</TotalBoxCell>
                    <TotalBoxCell style={{ width: 'calc(100% - 110px)', fontWeight: 'bold' }}>
                        {toBRL(total)}
                    </TotalBoxCell>
                </TotalBoxRow>

            </TotalBox>
        </Box>
    )
}